import db from "../../db";
import { SET_TIERS, SET_SUBCONTRACTORS, SET_CUSTOMERS, SET_CUSTOMER_SEARCH } from "./tiersConstants";
import { throwErrorMessage } from "../../lib/error_helper";
import { fetchWithTimeout } from "../../lib/fetch_wrapper";

function setTiersAction(tiers) {
    return {
        type: SET_TIERS,
        tiers: tiers,
    };
}

function setCustomerSearchAction(customerSearch) {
    return {
        type: SET_CUSTOMER_SEARCH,
        customerSearch,
    };
}

function setSubcontractorsAction(subcontractors) {
    return {
        type: SET_SUBCONTRACTORS,
        subcontractors: subcontractors,
    };
}

function setCustomersAction(customers) {
    return {
        type: SET_CUSTOMERS,
        customers,
    };
}

export function searchCustomersNearGeolocation(position) {
    return (dispatch) => {
        const maxDistance = 20000; //20km

        const headers = new Headers({ "Content-Type": "application/json" });
        const body = JSON.stringify({
            type: "customer",
            longitude: position.coords.longitude,
            latitude: position.coords.latitude,
            distance: maxDistance,
        });

        fetchWithTimeout("/api/v1/tiers/get_tiers_near_geolocation/", {
            method: "POST",
            headers: headers,
            body: body,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((customers) => {
                dispatch(setCustomersAction(customers));
            })
            .catch((err) => {
                console.error("Erreur : tiersActions - searchCustomersNearGeolocation", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des clients à proximité",
                    })
                );
            });
    };
}

export function searchSubcontractors(code) {
    return new Promise((resolve, reject) => {
        db.Subcontractor.toArray((subcontractors) => {
            let filteredSubcontractors = subcontractors.filter((s) =>
                s.name.toLowerCase().includes(code.toLowerCase())
            );
            return resolve(filteredSubcontractors);
        }).catch((err) => {
            console.error("Erreur : analyseRisquesActions - searchSubcontractors", err);
            return reject();
        });
    });
}

export function loadSubcontractors() {
    return (dispatch) => {
        db.Subcontractor.toArray((subcontractors) => {
            dispatch(setSubcontractorsAction(subcontractors));
        });
    };
}

export function getAndStoreSubcontractors(discreet) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });

        fetchWithTimeout("/api/v1/tiers/subcontractors/", {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((subcontractors) => {
                db.transaction("rw?", db.Subcontractor, async () => {
                    db.Subcontractor.toCollection()
                        .delete()
                        .then(() => {
                            for (let i = 0; i < subcontractors.length; i++) {
                                db.Subcontractor.put(subcontractors[i]);
                            }
                        });
                });
            })
            .catch((err) => {
                console.error("Erreur : tiersActions - getAndStoreSubcontractors", err);

                if (!discreet)
                    dispatch(
                        throwErrorMessage({
                            errorObject: err,
                            title: "Erreur",
                            message: "Erreur lors de la récupération des sous traitants",
                        })
                    );
            });
    };
}

export function getTiers() {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/tiers/get_tiers/", {
            method: "POST",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((tiers) => {
                dispatch(setTiersAction(tiers));
            })
            .catch((err) => {
                console.error("Erreur : tiersActions - getTiers", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération des tiers",
                    })
                );
            });
    };
}

export function customerSearch(code, user) {
    return (dispatch) => {
        const headers = new Headers({ "Content-Type": "application/json" });
        fetchWithTimeout("/api/v1/tiers/get_customer/" + user.id + "/" + code, {
            method: "GET",
            headers: headers,
        })
            .then((response) => {
                if (!response.ok) throw Error(response.statusText);

                return response;
            })
            .then((response) => response.json())
            .then((customer) => {
                dispatch(setCustomerSearchAction(customer));
            })
            .catch((err) => {
                console.error("Erreur : tiersActions - customerSearch", err);
                dispatch(
                    throwErrorMessage({
                        errorObject: err,
                        title: "Erreur",
                        message: "Erreur lors de la récupération de la fiche client",
                    })
                );
            });
    };
}

export function clearCustomerSearch() {
    return (dispatch) => {
        dispatch(setCustomerSearchAction(null));
    };
}
